import { useMutation, useQueryClient } from "@tanstack/react-query";

import { queryKeys } from "@/shared/utils/queryKeys";
import { getAccessToken } from "@/shared/types/auth";

async function saveCalendlyBooking(
  estateId: number,
  eventUri: string,
  inviteeUri: string,
  source: string,
): Promise<unknown> {
  const accessToken = await getAccessToken();
  const url = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/communications/${estateId}/calendly-booking`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
    },
    body: JSON.stringify({
      estate_id: estateId,
      event_uri: eventUri,
      invitee_uri: inviteeUri,
      source,
    }),
  });
  if (!response.ok) throw new Error("Failed to save booking");
  return response.json();
}

export function useSaveCalendlyBooking(estateId: number | undefined, source: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ eventUri, inviteeUri }: { eventUri: string; inviteeUri: string }) => {
      if (!estateId) throw new Error("Estate ID required");
      return saveCalendlyBooking(estateId, eventUri, inviteeUri, source);
    },
    onSuccess: () => {
      if (estateId) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.calendly.booking(estateId, source),
          refetchType: "all",
        });
      }
    },
  });
}
